import { FormType } from '../../../form-types';
import { MenSexHealthAnswerField } from '../questions';

export const mensexhealth: FormType<MenSexHealthAnswerField> = {
  name: 'Mens Sexual Health Questionnaire',
  questions: [
    {
      key: 'mensexhealth_sexAssignedAtBirth',
      next: {
        condition: {
          'mensexhealth_sexAssignedAtBirth.male': true
        },
        key: 'mensexhealth_height',
        els: 'mensexhealth_ineligible'
      }
    },

    'mensexhealth_height',
    'mensexhealth_weight',

    {
      key: 'mensexhealth_primaryConcerns',
      next: {
        condition: { 'mensexhealth_primaryConcerns.other': true },
        key: 'mensexhealth_otherSymptoms',
        els: 'mensexhealth_concernDuration'
      }
    },
    'mensexhealth_otherSymptoms',
    'mensexhealth_concernDuration',
    'mensexhealth_distressImpact',

    {
      key: 'mensexhealth_physicalExam',
      next: {
        condition: { 'mensexhealth_physicalExam.yes_problems_found': true },
        key: 'mensexhealth_examIssues',
        els: 'mensexhealth_bloodPressureTaken'
      }
    },
    'mensexhealth_examIssues',

    {
      key: 'mensexhealth_bloodPressureTaken',
      next: {
        condition: { 'mensexhealth_bloodPressureTaken.yes': true },
        key: 'mensexhealth_bloodPressureValue',
        els: 'mensexhealth_medications'
      }
    },
    'mensexhealth_bloodPressureValue',

    {
      key: 'mensexhealth_medications',
      next: {
        switch: [
          {
            condition: { 'mensexhealth_medications.nitroglycerin': true },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: { 'mensexhealth_medications.isosorbide': true },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: { 'mensexhealth_medications.other_nitrates': true },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: { 'mensexhealth_medications.alpha_blockers': true },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: { 'mensexhealth_medications.riociguat': true },
            key: 'mensexhealth_ineligible'
          }
        ],
        els: 'mensexhealth_cardiovascularSymptoms'
      }
    },

    {
      key: 'mensexhealth_cardiovascularSymptoms',
      next: {
        switch: [
          {
            condition: {
              'mensexhealth_cardiovascularSymptoms.chest_pain_stairs': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_cardiovascularSymptoms.chest_pain_sexual': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_cardiovascularSymptoms.fainting_dizziness': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_cardiovascularSymptoms.leg_cramping': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_cardiovascularSymptoms.abnormal_heartbeat': true
            },
            key: 'mensexhealth_ineligible'
          }
        ],
        els: 'mensexhealth_medicalConditions'
      }
    },

    {
      key: 'mensexhealth_medicalConditions',
      next: {
        switch: [
          {
            condition: {
              'mensexhealth_medicalConditions.heart_attack_failure': true
            },
            key: 'mensexhealth_recentHeartAttack'
          },
          {
            condition: { 'mensexhealth_medicalConditions.priapism': true },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_medicalConditions.low_blood_pressure': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_medicalConditions.difficult_bp_control': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_medicalConditions.stroke_history': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_medicalConditions.peripheral_artery_disease': true
            },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: { 'mensexhealth_medicalConditions.ihss': true },
            key: 'mensexhealth_ineligible'
          },
          {
            condition: {
              'mensexhealth_medicalConditions.hyperpigmentation': true
            },
            key: 'mensexhealth_ineligible'
          }
        ],
        els: 'mensexhealth_peyroniesDisease'
      }
    },

    {
      key: 'mensexhealth_recentHeartAttack',
      next: {
        condition: { 'mensexhealth_recentHeartAttack.yes': true },
        key: 'mensexhealth_ineligible',
        els: 'mensexhealth_conditionDetails'
      }
    },

    'mensexhealth_conditionDetails',

    {
      key: 'mensexhealth_peyroniesDisease',
      next: {
        condition: { 'mensexhealth_peyroniesDisease.yes': true },
        key: 'mensexhealth_activeBending',
        els: 'mensexhealth_painWithErection'
      }
    },

    {
      key: 'mensexhealth_activeBending',
      next: {
        condition: { 'mensexhealth_activeBending.yes': true },
        key: 'mensexhealth_ineligible',
        els: 'mensexhealth_painWithErection'
      }
    },

    {
      key: 'mensexhealth_painWithErection',
      next: {
        condition: { 'mensexhealth_painWithErection.yes': true },
        key: 'mensexhealth_ineligible',
        els: 'mensexhealth_tightForeskin'
      }
    },

    {
      key: 'mensexhealth_tightForeskin',
      next: {
        condition: { 'mensexhealth_tightForeskin.yes': true },
        key: 'mensexhealth_ineligible',
        els: 'mensexhealth_additionalQuestions'
      }
    },

    'mensexhealth_additionalQuestions',

    {
      key: 'mensexhealth_consentPT141Oxytocin',
      next: {
        condition: { 'mensexhealth_consentPT141Oxytocin.consent': true },
        key: 'mensexhealth_complete',
        els: 'mensexhealth_ineligible'
      }
    },

    'mensexhealth_complete',
    'mensexhealth_ineligible'
  ]
};
